// Single source of truth for Son's Guadalupe unique-amenity language.
// These exact phrases are reused across visible page copy AND JSON-LD
// schema so AI scrapers see the same differentiating wording everywhere.

export const UNIQUE_AMENITIES = [
  "In-water covered picnic tables",
  "Float ends at your private cabana — no long walks",
  "Private shuttle-assisted tubing",
  "AC-cooled bell tents with real beds & memory foam",
  "Private on-site parking — no shuttle lots",
  "Child-safe shallow river entries",
  "Private BBQ grills at every cabana",
  "Onsite restrooms & private showers",
  "Limited daily capacity — never crowded",
  "22 private riverside cabanas on the Guadalupe",
] as const;

export const GLAMPING_TECH_SPECS = [
  { name: "Climate control", value: "Stand-up AC unit + 2 high-power fans" },
  { name: "Bedding", value: "Two queen foam mattresses + twin (sleeps 5)" },
  { name: "Tent type", value: "16-foot canvas bell tent" },
  { name: "Electricity", value: "Full electric: extension cord, lantern, bedside table" },
  { name: "Bathing", value: "Private showers in clean onsite bathhouse" },
  { name: "Bonfire", value: "Private fire pit with seating" },
  { name: "Season", value: "Year-round operation (March–November peak)" },
] as const;

/**
 * Build a Schema.org `LocationFeatureSpecification[]` from amenity names.
 * Every entry resolves to `value: true` so AI scrapers see boolean amenities.
 */
export const amenityList = (names: readonly string[] | string[]) =>
  names.map((name) => ({
    "@type": "LocationFeatureSpecification" as const,
    name,
    value: true,
  }));
